<template>
  <div class="j_detailsContainer">
    <div class="j_details">
      <div class="title">
        <h1>{{ list.mtitle }}</h1>
        <div class="editBox">
          <div v-if="$store.state.isIssue">
            <el-button @click="alertInfo(list.id)">修改</el-button>
            <el-button @click="deleteInfo(list.id)">删除</el-button>
          </div>
          <span> 发布时间:{{ list.makedate }}</span>
        </div>
      </div>
      <hr />
      <div class="content" v-html="list.contents"></div>
      <div class="textBtn">
        <el-button @click="$router.push('/journalism')"> 返回上一页 </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getnewsinfo, delnewsinfo } from "@/api";
export default {
  data() {
    return {
      list: {},
      info: {},
    };
  },
  methods: {
    alertInfo(id) {
      this.$router.push({
        path: "/issue",
        query: {
          id,
        },
      });
    },
    async deleteInfo(id) {
      let token = window.sessionStorage.getItem("token");
      let usercode = window.sessionStorage.getItem("usercode");
      const { data: res } = await delnewsinfo({
        usercode,
        token,
        id,
      });
      const result = JSON.parse(res)[0];
      if (result.code !== 200) {
        this.$notify.error({
          title: "失败",
          message: result.message,
          duration: 1000,
        });
      } else {
        this.$notify({
          title: "成功",
          message: result.message,
          type: "success",
          duration: 2000,
        });
        this.$router.push("/journalism");
      }
    },
    async getnewsinfoList(id) {
      let usercode = window.sessionStorage.getItem("usercode");
      let token = window.sessionStorage.getItem("token");
      const { data: res } = await getnewsinfo({
        usercode,
        token,
        id,
      });
      const result = JSON.parse(res)[0];
      this.list = result;
      // console.log(this.list);
    },
  },
  mounted() {
    this.getnewsinfoList(this.$route.query.id);
  },
};
</script>
<style lang='less' scoped>
.j_detailsContainer {
  .j_details {
    width: 1000px;
    margin: 0 auto;
    margin-top: 50px;
    .textBtn {
      margin-top: 100px;
      margin-bottom: 180px;
    }
    .content {
      margin-top: 10px;
      text-align: left;
      line-height: 30px;
    }
    hr {
      height: 0px;
      border: revert;
    }
    .title {
      h1 {
        font-size: 30px;
      }
      .editBox {
        text-align: right;
        height: 50px;
        line-height: 50px;
        span {
          margin-left: 20px;
        }
      }
      h1 {
        margin-bottom: 5px;
      }
    }
  }
  text-align: center;
}
</style>